import * as actionType from "./actions/assetsAction";

const initialState = {
  list: [],
  message: "",
  modalOpen: false,
  loading: false,
  isAssetEdit: false,
  isAssetList: true,
  isAssetCreate: false,
  apiStatus: false,
};

export default function assetsReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.GET_ASSETS_LIST:
      return {
        ...state,
        loading: false,
        modalOpen: false,
        isAssetList: true,
        isAssetEdit: false,
        isAssetCreate: false,
        message: "",
        AssetsDetail: action.payload,
      };
    case actionType.ASSETS_API_START:
      return {
        ...state,
        loading: action.payload.loading,
        modalOpen: action.payload.modalOpen,
        message: action.payload.message,
        apiStatus: action.payload.apiStatus,
      };
    case actionType.GET_SELECTED_ASSETS_LIST:
      return {
        ...state,
        loading: false,
        modalOpen: false,
        isAssetList: true,
        isAssetEdit: false,
        isAssetCreate: false,
        message: "",
        SelectedAssetsDetail: action.payload,
      };
    case actionType.GET_SELECTED_ASSETS_SUB_CATEGORY:
      return {
        ...state,
        loading: false,
        modalOpen: false,
        message: "",
        SelectedSubCategory: action.payload,
      };

    case actionType.GET_ASSET_NAME:
      return {
        ...state,
        loading: false,
        SelectedAssetNameDetails: action.payload,
      };
    case actionType.IS_ASSET_EDIT:
      return {
        ...state,
        isAssetEdit: action.payload,
        isAssetList: false,
        isAssetCreate: false,
      };
    case actionType.IS_ASSET_CREATE:
      return {
        ...state,
        isAssetEdit: false,
        isAssetList: false,
        isAssetCreate: action.payload,
      };
    case actionType.IS_ASSET_LIST:
      return {
        ...state,
        isAssetEdit: false,
        isAssetCreate: false,
        modalOpen: false,
        isAssetList: action.payload,
      };

    default:
      return state;
  }
}
